import ProcessFlow from "./ProcessFlow";
import ProductionOutputDetails from "./ProductionOutputDetails";
import YieldEfficiency from "./YieldEfficiency";
import Operations from "./Operations";
import "./dashboard-sections.css";
import { useGetBiggestDailyQuery } from "../dashBoardApi";
import { getCurrentDate, makeLotNumber, makePriorLotNumber } from "../../../helpers/Utils";
import { useState } from "react";

const BiggestDaily = ({ }) => {

  const [currentDate, setCurrentDate] = useState(getCurrentDate("YYYY-MM-DD"));
  

  const {
    data : biggestDailyData,
    isLoading : biggestDailyLoading,
    isFetching : biggestDailyFetching,
    isError : biggestDailyError,
    refetch
  } = useGetBiggestDailyQuery({
    date:currentDate,
    priorLotNumber : makePriorLotNumber(currentDate),
    currentLotNumber : makeLotNumber(),
  });

  const isLoading = false;

  return (
    <div className="db-section">
      {/* ── Process Flow + Production Output | Yield & Efficiency + Operations ── */}
      <div className="db-main-grid mt-3">
        {/* Left column */}
        <div className="db-main-left">
          <ProcessFlow isLoading={biggestDailyLoading} data={biggestDailyData?.data} />
          <ProductionOutputDetails isLoading={biggestDailyLoading} data={biggestDailyData?.data} />
        </div>
        {/* Right column */}
        <div className="db-main-right">
          <YieldEfficiency isLoading={biggestDailyLoading} data={biggestDailyData?.data}  />
          <Operations isLoading={biggestDailyLoading} data={biggestDailyData?.data} />
        </div>
      </div>
    </div>
  );
};

export default BiggestDaily;
